export const INSTRUMENTS = {
  flute: {
    name: 'Flauto',
    enabled: true,
    program: 73
  },
  piano: {
    name: 'Piano',
    enabled: true,
    program: 0
  },
  guitar: {
    name: 'Chitarra',
    enabled: true,
    program: 24
  },
  xylophone: {
    name: 'Xilofono',
    enabled: true,
    program: 13
  }
};
